"use strict";

exports.__esModule = true;
exports.PUB_SUB_CHANNEL_MEMBER_COMMENTS = exports.PUB_SUB_CHANNEL_MEMBER_POSTS = exports.PUB_SUB_CHANNEL_MEMBER_LIKES = exports.PUB_SUB_CHANNEL_MEMBER_DRAFTS = exports.PUB_SUB_CHANNEL_MODAL = exports.PUB_SUB_CHANNEL_APP = void 0;
var PUB_SUB_CHANNEL_APP = 'app';
exports.PUB_SUB_CHANNEL_APP = PUB_SUB_CHANNEL_APP;
var PUB_SUB_CHANNEL_MODAL = 'modal';
exports.PUB_SUB_CHANNEL_MODAL = PUB_SUB_CHANNEL_MODAL;
var PUB_SUB_CHANNEL_MEMBER_DRAFTS = 'member-drafts';
exports.PUB_SUB_CHANNEL_MEMBER_DRAFTS = PUB_SUB_CHANNEL_MEMBER_DRAFTS;
var PUB_SUB_CHANNEL_MEMBER_LIKES = 'member-likes';
exports.PUB_SUB_CHANNEL_MEMBER_LIKES = PUB_SUB_CHANNEL_MEMBER_LIKES;
var PUB_SUB_CHANNEL_MEMBER_POSTS = 'member-posts';
exports.PUB_SUB_CHANNEL_MEMBER_POSTS = PUB_SUB_CHANNEL_MEMBER_POSTS;
var PUB_SUB_CHANNEL_MEMBER_COMMENTS = 'member-comments';
exports.PUB_SUB_CHANNEL_MEMBER_COMMENTS = PUB_SUB_CHANNEL_MEMBER_COMMENTS;